export default {
  grDate: 'GR Date',
  plants: 'Plant',
  validationScanResult: 'Validation Result',
  cartonNumber: 'Carton Number',
  asnDn: 'ASN',
  skuNumber: 'ASN SKU',
  asnDnQty: 'ASN Qty',
  scanQty: 'Scan Qty',
  deltaQty: 'Delta Qty',
  productName: 'Product Name',
  latestValidationScanResult: 'Latest System Validation Result',
  isRelabel: 'Is Relabel',
  isMislabel: 'Mislabeling',
  opitionError: 'Carton Number, ASN, or GR Date must be filled in at least one of the three options!',
  qty: 'Qty',
  accurate: 'Accurate',
  Unexpected: 'Unexpected',
  epcShortage: 'EPC Shortage',
  epcOverage: 'EPC Overage',
  upcMismatched: 'UPC Mismatched',
  manualConfirm: 'Manual Confirm',
  newCarton: 'New Carton',
  nfcSku: 'NFC SKU',
  specialSku: 'Special SKU',
  lastScannedDevice: 'Last Scanned Device Code',
  lastScanTime: 'Last Scan Time',
  misMatchedSku: 'Mismatched SKU',
  unknownSku: 'Unknown SKU',
  misMatchedQty: 'Mismatched Qty',
  validationResult: 'Validation Result',
  ttlCartonQty: 'TTL Carton Qty',
  mislabelingCartonQty: 'Mislabel CTN Qty',
  total: 'Total',
  cartonPe: 'Carton PE',
  // OB 报表专用，其余文案与 IB 共用
  obGrDate: 'GI Date',
  obAsnDn: 'Packlist',
  obSkuNumber: 'GI SKU',
  obAsnDnQty: 'GI Qty',
  obOpitionError: 'Carton Number, Packlist, or GI Date must be filled in at least one of the three options!'
}
